import { render, staticRenderFns } from "./BuyTab3.vue?vue&type=template&id=70cdf65b&scoped=true&lang=pug&"
import script from "./BuyTab3.vue?vue&type=script&lang=js&"
export * from "./BuyTab3.vue?vue&type=script&lang=js&"
import style0 from "./BuyTab3.vue?vue&type=style&index=0&id=70cdf65b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cdf65b",
  null
  
)

export default component.exports